// extracted by mini-css-extract-plugin
export default {"grid":"RequestDemo_grid__gyeXM","copy":"RequestDemo_copy__US+NI","title":"RequestDemo_title__WYTe6","media":"RequestDemo_media__WqbRi"};